import { render, staticRenderFns } from "./GatewayProcessListings.vue?vue&type=template&id=af374d50&"
import script from "./GatewayProcessListings.vue?vue&type=script&lang=js&"
export * from "./GatewayProcessListings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports